import { typography } from "./typography"
import { color } from "./colors"

export const menu = {
  typography: typography.menuPosition,
  backgroundColor: [color.white, color.white],
  color: [color.neutral20, color.neutral20],
  colorHover: [color.primary40, color.primary40],
  fontBackgroundColor: [color.white, color.primary100],
  borderBottom: [
    `1px solid rgba(255, 255, 255, 0.2)`,
    `1px solid ${color.neutral80}`,
  ],
  hamburgerColor: [color.primary40, color.primary40],
  navigationColor: [color.white, color.neutral20],
  textTransform: "",
}

export const header = {
  size: 2,
  typography: [typography.h900, typography.h700, typography.h500],
  color: color.neutral20,
  secondaryColor: color.neutral20,
  textTransform: "",
  padding: "4px 0 32px",
  margin: "",
  position: "relative",
}

export const text = {
  typography: typography.bodyM,
  linkTypography: typography.button,
  textTransform: "",
}

export const link = {
  typography: typography.menuPosition,
  textTransform: "",
  textDecoration: "none",
  transition: "color 0.3s ease",
}

export const button = {
  typography: typography.buttonXS,
  typographyXXS: typography.buttonS,
  typographyXS: typography.button,
  width: "",
  height: "",
  backgroundColor: ["transparent", color.primary40],
  color: [color.primary40, color.white],
  textTransform: "uppercase",
  position: "relative",
}

export const footer = {
  typography: typography.bodyS,
  backgroundColor: color.secondary20,
  color: color.white,
}
